import { ElementRef, Optional, Directive } from "@angular/core";
import { NgControl, NgModel } from "@angular/forms";

@Directive({
    selector: '[ngModel], [formControl], [formControlName]',
    standalone: false
})
export class NativeElementInjectorDirective {
  constructor(private el: ElementRef, private control: NgControl, @Optional() private model: NgModel) {
  }
  ngOnInit() {
    if (!!this.model)
      (<any>this.model.control).nativeElement = this.el.nativeElement;
    else
      (<any>this.control).nativeElement = this.el.nativeElement;
  }
}
